import { IAutoMapper } from "../../../../../../core/automapper/interfaces";
import { StringHelper } from "../../../../../../utilities/contracts/string-helper";

export const mapOverreadFeedbackQueryItem = (automapper: IAutoMapper): void => {
  automapper.createMap("default", "OverreadFeedbackQueryItem")
    .forMember("chaseId", o => o.chaseId)
    .forMember("measureCode", o => o.measureCode)
    .forMember("codingUserId", o => o.codingUserId)
    .forMember("codingUserName", o => o.codingUserName)
    .forMember("codingDate", o => o.codingDate)
    .forMember("QAUserId", o => o.QAUserId)
    .forMember("QAUserName", o => o.QAUserName)
    .forMember("QADate", o => o.QADate)
    .forMember("errorCount", o => o.errorCount)
    .forMember("errorReviewCompletedCount", o => o.errorReviewCompletedCount)
    .forMember("errorReviewToBeCompletedCount", o => o.errorReviewToBeCompletedCount)
    .forMember("codingReceiptStatus", o => o.codingReceiptStatus)
    .forMember("QAReceiptStatus", o => o.QAReceiptStatus)
    .forMember("status", o => o.chaseOverreadFeedbackStatus)
    .forMember("recordCount", o => o.recordCount)
    .forMember("codingReviewMode", o => o.codingReviewMode);
};

export class OverreadFeedbackQueryItem {
  chaseId: number;
  measureCode: string;
  codingUserId: number;
  codingUserName: string;
  codingDate: Date;
  QAUserId: number;
  QAUserName: string;
  QADate: Date;
  managerUserId: number;
  managerUserName: string;
  errorCount: number;
  errorReviewCompletedCount: number;
  errorReviewToBeCompletedCount: number;
  codingReceiptStatus: string;
  QAReceiptStatus: string;
  chaseOverreadFeedbackStatus: string;
  recordCount: number;
  codingReviewMode: string;
  constructor(options: Partial<OverreadFeedbackQueryItem>) {
    this.chaseId = options.chaseId;
    this.measureCode = StringHelper.clean(options.measureCode);
    this.codingUserId = options.codingUserId;
    this.codingUserName = StringHelper.clean(options.codingUserName);
    this.codingDate = options.codingDate;
    this.QAUserId = options.QAUserId;
    this.QAUserName = StringHelper.clean(options.QAUserName);
    this.QADate = options.QADate;
    this.managerUserId = options.managerUserId;
    this.managerUserName = StringHelper.clean(options.managerUserName);
    this.errorCount = options.errorCount;
    this.errorReviewCompletedCount = options.errorReviewCompletedCount;
    this.errorReviewToBeCompletedCount = options.errorReviewToBeCompletedCount;
    this.codingReceiptStatus = StringHelper.clean(options.codingReceiptStatus);
    this.QAReceiptStatus = StringHelper.clean(options.QAReceiptStatus);
    this.chaseOverreadFeedbackStatus = StringHelper.clean(options.chaseOverreadFeedbackStatus);
    this.recordCount = options.recordCount;
    this.codingReviewMode = options.codingReviewMode;
  }
}
